import { EntityStatusBadge } from '@frontend/components/badge';
import { JobStateName } from '@frontend/report/types';
import React from 'react';

import { useJobStateBadge } from './job-state-badge.controller';

const ID = 'job-state-badge';

export interface JobStateBadgeProps {
    state: JobStateName;
}

export const JobStateBadge = (props: JobStateBadgeProps) => {
    const viewProps = useJobStateBadge(props);
    return (
        <EntityStatusBadge
            id={ID}
            label={viewProps.displayName}
            variant={viewProps.variant}
        />
    );
};
